import { Open } from './../../../../../web-ssr/src/stories/notification.stories'
import hcAxios from 'core/utils/hcAxios'
import { TBaseResponse, TResponse } from 'core/service/hcResponse'
// 站内信通知接口
enum API {
  // 合约预警记录删除
  InmailContractDelete = '/hk-web/inmail/contract/delete',
  // 查询合约预警记录列表
  InmailContractList = '/hk-web/inmail/contract/list',
  // 行情异动记录删除
  InmailMarketmoveDelete = '/hk-web/inmail/marketmove/delete',
  // 查询行情异动记录列表
  InmailMarketmoveList = '/hk-web/inmail/marketmove/list',
  // 我的消息_最新消息
  InmailMessageCenter = '/hk-web/inmail/message/center',
  // 站内信通知_清除未读/删除消息
  InmailMessageClear = '/hk-web/inmail/message/clear',
  // 我的消息_查询窗口消息列表
  InmailMessageList = '/hk-web/inmail/message/list',
  // 获取通知模块的未读数量
  InmailModuleUnread = '/hk-web/inmail/module/unread',
  // 获取站内信&价格订阅配置
  InmailNoticeConfig = '/hk-web/inmail/notice/config',
  // 设置通知推送状态
  InmailNotifyActivate = '/hk-web/inmail/notify/activate',
  // 获取当前用户推送设置状态
  InmailNotifyStatus = '/hk-web/inmail/notify/status',
  // 现货行情_创建价格订阅
  InmailPricealertCreate = '/hk-web/inmail/pricealert/create',
  // 现货行情_删除价格订阅
  InmailPricealertDelete = '/hk-web/inmail/pricealert/delete',
  // 现货行情_查询价格订阅列表
  InmailPricealertList = '/hk-web/inmail/pricealert/list',
  // 现货行情_价格订阅提醒删除
  InmailPricealertLogDelete = '/hk-web/inmail/pricealert/log/delete',
  // 现货行情_查询价格订阅提醒列表
  InmailPricealertLogList = '/hk-web/inmail/pricealert/log/list',
  // kafka站内信通知
  KafkaInmNotification = '/hk-web/kafka/InmNotification',
  // 极光通知推送说明
  JpushInmNotification = '/hk-web/jpush/InmNotification',
  // 消息列表
  V2InmailMessageList = '/hk-web/v2/inmail/message/list',
  // 消息未读状态
  V2InmailMessageStatus = '/hk-web/v2/inmail/message/status',
  // 消息未读数量
  V2InmailMessageUnReadCount = '/hk-web/v2/inmail/message/unReadCount',
  // 获取消息分类
  V2InmailMessageClassify = '/hk-web/v2/inmail/message/classify',
}

// 定义业务类型枚举
export enum BizType {
  UserRegisterSuccess = 1, // 用户注册成功
  UserLoginSuccess = 2, // 用户登录成功
  RealNameAuthFailed = 3, // 实名认证审核不通过
  RealNameAuthSuccess = 4, // 实名认证审核通过
  SystemUpdate = 5, // 系统更新
  NewCoinEarlyKnow = 6, // 新币早知道
  LatestActivity = 7, // 最新活动
  AnnouncementMessage = 8, // 公告消息
  MarketFluctuation = 9, // 行情异动
  PriceSubscription = 10, // 价格订阅
  ContractWarning = 11, // 合约预警
  DepositSuccess = 12, // 充币成功
  WithdrawalSuccess = 13, // 提币成功
  UserNotification = 14, // 用户通知
  NFTDepositSuccess = 15, // NFT充值成功
  NFTWithdrawalSuccess = 16, // NFT提现成功
  OpenPositionFailed = 17, // 开仓失败
  CopyTraderPause = 18, // 跟单交易员暂停带单
  TraderRemoved = 19, // 交易员移除
  TraderDisqualified = 20, // 交易员被取消资格
  TriggerTakeProfitStopLoss = 21, // 触发止盈/止损
  CopyTradeApplicationApproved = 22, // 带单申请审核成功
  CopyTradeSuccess = 23, // 跟单员跟单成功
  TraderDisqualifiedAgain = 24, // 交易员被取消资格
  OrderBearer = 25, // 带单相关消息
  TraderProfitRatioAdjustment = 26, // 交易员分润比例调整
  TraderUpgradeSuccess = 27, // 交易员升级成功
  OpenPositionSuccess = 28, // 开仓成功
  ClosePositionSuccess = 29, // 平仓成功
  TraderUpgradeFailed = 30, // 交易员升级失败
  CopyTradeApplicationRejected = 31, // 带单申请审核不通过

  // 福利中心相关
  BenefitsCenterHome = 51, // 福利中心首页
  BenefitsCenterReward = 52, // 福利中心空投奖励
  BenefitsCenterTask = 53, // 福利中心我的任务
  BenefitsCenterMyReward = 54, // 福利中心我的奖励

  // 账户相关
  AccountInfoModified = 50, // 修改信息

  // 充值提现相关
  DepositProcessing = 92, // 充值处理中
  BackendRewardDistribution = 93, // 后台奖励发放
  TradingFundRelated1 = 94, // 交易基金相关1
  TradingFundRelated2 = 95, // 交易基金相关2
  TradingFundRelated3 = 96, // 交易基金相关3
  TradingFundRelated4 = 97, // 交易基金相关4

  // C2C相关
  C2CMerchantApproved = 112, // C2C商家审核通过
  C2COrderCreated = 113, // C2C订单创建
  C2CBuyerPayment = 114, // C2C买家付款
  C2COrderCompleted = 115, // C2C订单完成
  C2COrderAppeal = 116, // C2C订单申诉
  C2COrderCancelled = 117, // C2C订单取消
  C2CMerchantRejected = 118, // C2C商家审核不通过
  RiskDepositFrozen = 119, // 风险充值冻结

  // 直播相关
  LiveBroadcastUpcoming = 220, // 直播即将热播

  OpenTradeNotification = 221, // 221 开盘通知

  // 返现活动相关
  CashbackActivity = 250, // 返现活动首页
  CashbackDetail1 = 251, // 返现活动详情1
  CashbackDetail2 = 252, // 返现活动详情2
  CashbackDetail3 = 253, // 返现活动详情3
  CashbackDetail4 = 254, // 返现活动详情4

  // 特殊标签类型
  LatestAnnouncement = 105, // 最新公告
  SystemMaintenanceUpdate1 = 106, // 系统维护更新1
  OtherAnnouncements = 107, // 其他公告
  SystemMaintenanceUpdate2 = 108, // 系统维护更新2
  WalletMaintenanceStatus = 109, // 钱包维护状态

  // 账户中心相关
  AccountCenter = 111, // 账户中心
}

// 定义通知模块枚举类型
export enum ModuleCode {
  SystemNotification = 1, // 系统通知
  AnnouncementMessage = 2, // 公告消息
  LatestActivity = 3, // 最新活动
  NewCoinEarlyKnow = 4, // 新币早知道
  PriceSubscription = 5, // 价格订阅
  MarketFluctuation = 6, // 行情异动
  ContractWarning = 7, // 合约预警
  ContractCopy = 8, // 合约跟单
  MarketTrade = 9, // 行情交易
  NewTaskRemind = 10, // 新手任务提醒
  RewardGifting = 11, // 空投奖励
  Market = 20, // 行情
  Trade = 21, // 交易
}

// 定义预警类型枚举类型
export enum WarnType {
  LiquidationWarning = 1, // 强平预警
  LiquidationNotice = 2, // 强平通知
  DeliveryNotice = 3, // 交割通知
  GeneralMessage = 4, // 普通消息
  CopyTradeMessage = 5, // 跟单消息
  LeadTradeMessage = 6, // 带单消息
}

// 定义已读状态枚举类型
export enum RangeType {
  All = 0, // 所有
  OneOrMore = 1, // 一个或多个
}

// 定义子模块枚举类型
export enum SubmoduleCode {
  LatestActivity = 1, // 最新活动
  NewCoinEarlyKnow = 2, // 新币早知道
  PlatformAnnouncement = 3, // 平台公告
  DelistingInfo = 4, // 下架讯息
  SystemMessage = 5, // 系统消息
  Deposit = 6, // 充值
  Withdrawal = 7, // 提现
  C2C = 8, // C2C
  PriceSubscription = 9, // 价格订阅
  MarketFluctuation = 10, // 行情异动
  Spot = 11, // 现货
  Contract = 12, // 合约
  CopyTrade = 13, // 跟单
  LeadTrade = 14, // 带单
  Activity = 15, // 活动
}

export enum InstType {
  Spot = 2, // 现货
  Margin = 3, // 杠杆
  Perpetual = 4, // 永续合约
  Delivery = 5, // 交割合约
  Option = 6, // 期权
}

export type TPostInmailContractDeleteParams = {
  id?: number // 合约预警id
}
export type TPostInmailContractDeleteResponse = TResponse<number>
export const postInmailContractDelete = (params?: TPostInmailContractDeleteParams) => {
  return hcAxios.post<TPostInmailContractDeleteResponse>(API.InmailContractDelete, params)
}

export type TGetInmailContractListParams = {
  contractCode?: string // 合约交易对编码，比如BTCUSDT
  count?: boolean // 是否返回总记录数，默认true
  pageNum?: number // 页码
  pageSize?: number // 每页显示条数
}
export type TGetInmailContractListResponse = TResponse<
  {
    bizType?: BizType
    content?: string // 内容
    contractCode?: string // 合约交易对编码，比如BTCUSDT
    createdTime?: number // 创建时间，13位时间戳
    extras?: any // 自定义参数，一般用于前端跳转
    id?: number // 消息id
    moduleCode?: ModuleCode // 通知模块 1系统通知 2公告消息 3最新活动 4新币早知道 5价格订阅 6行情异动 7合约预警 8合约跟单
    title?: string // 标题
    warnType?: WarnType // 预警类型 1强平预警 2强平通知 3交割通知 4普通消息 5跟单消息 6带单消息
  }[]
>
export const getInmailContractList = (params?: TGetInmailContractListParams) => {
  return hcAxios.get<TGetInmailContractListResponse>(API.InmailContractList, { params })
}

export type TPostInmailMarketmoveDeleteParams = {
  id?: number // 行情异动id
}
export type TPostInmailMarketmoveDeleteResponse = TResponse<number>
export const postInmailMarketmoveDelete = (params?: TPostInmailMarketmoveDeleteParams) => {
  return hcAxios.post<TPostInmailMarketmoveDeleteResponse>(API.InmailMarketmoveDelete, params)
}

export type TGetInmailMarketmoveListParams = {
  count?: boolean // 是否返回总记录数，默认true
  pageNum?: number // 页码
  pageSize?: number // 每页显示条数
  tradeId?: number // 交易对id
}
export type TGetInmailMarketmoveListResponse = TResponse<
  {
    baseCurrency?: string // 计价币
    changeMove?: string // 涨跌幅百分比
    changeType?: number // 幅度类型，1涨幅 2跌幅
    createdTime?: number // 创建时间，13位时间戳
    id?: number // 消息id
    marketPeriod?: number // 时间范围，单位min
    quoteCurrency?: string // 标的币
    spotPrice?: string // 异动价格
    tradeId?: number // 交易对id
  }[]
>
export const getInmailMarketmoveList = (params?: TGetInmailMarketmoveListParams) => {
  return hcAxios.get<TGetInmailMarketmoveListResponse>(API.InmailMarketmoveList, { params })
}

export type TGetInmailMessageCenterParams = any
export type TGetInmailMessageCenterResponse = TResponse<
  {
    bizType?: BizType
    content?: string // 内容
    createdTime?: number // 创建时间，13位时间戳
    id?: number // 消息id
    jumpApp?: string // APP跳转链接
    jumpLink?: string // 网页跳转链接
    moduleCode?: ModuleCode // 通知模块 1系统通知 2公告消息 3最新活动 4新币早知道 5价格订阅 6行情异动 7合约预警 8合约跟单 9行情交易 10新手任务提醒 11空投奖励
    moduleIcon?: string // 模块图标
    supportCode?: string // 站内code
    title?: string // 标题
  }[]
>
export const getInmailMessageCenter = (params?: TGetInmailMessageCenterParams) => {
  return hcAxios.get<TGetInmailMessageCenterResponse>(API.InmailMessageCenter, { params })
}

export type TPostInmailMessageClearParams = {
  isDeleted?: number // 是否删除，0表示不删除 1表示删除
  isReaded?: number // 是否设为已读 0表示不设为已读 1表示设为已读
  moduleCode?: ModuleCode // 通知模块 0表示全部 1系统通知 2公告消息 3最新活动 4新币早知道 5价格订阅 6行情异动 7合约预警
}
export type TPostInmailMessageClearResponse = TResponse<any>
export const postInmailMessageClear = (params?: TPostInmailMessageClearParams) => {
  return hcAxios.post<TPostInmailMessageClearResponse>(API.InmailMessageClear, params)
}

export type TGetInmailMessageListParams = {
  client?: any // 客户端 2-Android 5-iOS
  count?: any // 是否返回总记录数，默认true
  moduleCode?: any // 通知模块 1系统通知 2公告消息 3最新活动 4新币早知道
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
}
export type TGetInmailMessageListResponse = TResponse<
  {
    bizType?: BizType
    content?: string // 内容
    createdTime?: number // 创建时间，13位时间戳
    id?: number // 消息id
    jumpApp?: string // APP跳转链接
    jumpLink?: string // 网页跳转链接
    moduleCode?: ModuleCode // 通知模块 1系统通知 2公告消息 3最新活动 4新币早知道 5价格订阅 6行情异动 7合约预警 8合约跟单 9行情交易 10新手任务提醒 11空投奖励
    moduleIcon?: string // 模块图标
    supportCode?: string // 站内code
    title?: string // 标题
  }[]
>
export const getInmailMessageList = (params?: TGetInmailMessageListParams) => {
  return hcAxios.get<TGetInmailMessageListResponse>(API.InmailMessageList, { params })
}

export type TGetInmailModuleUnreadParams = any
export type TGetInmailModuleUnreadResponse = TResponse<any>
export const getInmailModuleUnread = (params?: TGetInmailModuleUnreadParams) => {
  return hcAxios.get<TGetInmailModuleUnreadResponse>(API.InmailModuleUnread, { params })
}

export type TGetInmailNoticeConfigParams = any
export type TGetInmailNoticeConfigResponse = TResponse<{
  announcementIcon?: string // 公告君图标
  latestActivityIcon?: string // 最新活动图标
  newCoinIcon?: string // 新币早知道图标
  newtaskRemindIcon?: string // 新手任务提醒图标
  priceAlertMaxNum?: number // 价格订阅最多设置条数
  priceAlertPairNum?: number // 价格订阅单币对设置最大条数
  priceNoticeExpireDays?: number // 价格提醒有效期(天)
  rewardGiftingIcon?: string // 空投奖励图标
  systemIcon?: string // 系统通知图标
}>
export const getInmailNoticeConfig = (params?: TGetInmailNoticeConfigParams) => {
  return hcAxios.get<TGetInmailNoticeConfigResponse>(API.InmailNoticeConfig, { params })
}

export type TPostInmailNotifyActivateParams = {
  notifyType?: number // 通知类型 1合约订单预警 2行情异动提醒 3新币提醒 4最新活动提醒 16允许通过内部方式向我转账 17转账语音提醒开关 21地址白名单模式 22新地址提币锁定
  status?: boolean // 是否关闭推送 true关闭推送  false开启推送
}
export type TPostInmailNotifyActivateResponse = TResponse<any>
export const postInmailNotifyActivate = (params?: TPostInmailNotifyActivateParams) => {
  return hcAxios.post<TPostInmailNotifyActivateResponse>(API.InmailNotifyActivate, params)
}

export type TGetInmailNotifyStatusParams = any
export type TGetInmailNotifyStatusResponse = TResponse<any>
export const getInmailNotifyStatus = (params?: TGetInmailNotifyStatusParams) => {
  return hcAxios.get<TGetInmailNotifyStatusResponse>(API.InmailNotifyStatus, { params })
}

export type TPostInmailPricealertCreateParams = {
  alertType?: number // 提醒类型 1|价格上涨至 2|价格下跌至 3|24H涨幅超过 4|24H跌幅超过
  alertValue?: string // 提醒价格或涨跌幅
  currentPrice?: string // 当前价格
  isRepeated?: boolean // 是否重复提醒 0否 1是
  tradeId?: number // 交易对id
}
export type TPostInmailPricealertCreateResponse = TResponse<number>
export const postInmailPricealertCreate = (params?: TPostInmailPricealertCreateParams) => {
  return hcAxios.post<TPostInmailPricealertCreateResponse>(API.InmailPricealertCreate, params)
}

export type TPostInmailPricealertDeleteParams = {
  id?: number // 价格订阅id
}
export type TPostInmailPricealertDeleteResponse = TResponse<number>
export const postInmailPricealertDelete = (params?: TPostInmailPricealertDeleteParams) => {
  return hcAxios.post<TPostInmailPricealertDeleteResponse>(API.InmailPricealertDelete, params)
}

export type TGetInmailPricealertListParams = {
  count?: any // 是否返回总记录数，默认true
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  tradeId?: any // 交易对id
}
export type TGetInmailPricealertListResponse = TResponse<
  {
    alertType?: number // 提醒类型 1|价格上涨至 2|价格下跌至 3|24H涨幅超过 4|24H跌幅超过
    alertValue?: string // 提醒价格或涨跌幅
    baseCurrency?: string // 计价币
    createdTime?: number // 创建时间，13位时间戳
    expireTime?: number // 失效时间，13位时间戳
    id?: number // 消息id
    isRepeated?: boolean // 是否重复提醒 0否 1是
    quoteCurrency?: string // 标的币
    tradeId?: number // 交易对id
    userId?: number // 用户id
  }[]
>
export const getInmailPricealertList = (params?: TGetInmailPricealertListParams) => {
  return hcAxios.get<TGetInmailPricealertListResponse>(API.InmailPricealertList, { params })
}

export type TGetInmailPricealertLogDeleteParams = {
  id?: any // 价格订阅提醒记录id
}
export type TGetInmailPricealertLogDeleteResponse = TResponse<number>
export const getInmailPricealertLogDelete = (params?: TGetInmailPricealertLogDeleteParams) => {
  return hcAxios.get<TGetInmailPricealertLogDeleteResponse>(API.InmailPricealertLogDelete, { params })
}

export type TGetInmailPricealertLogListParams = {
  count?: any // 是否返回总记录数，默认true
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  tradeId?: any // 交易对id
}
export type TGetInmailPricealertLogListResponse = TResponse<
  {
    alertType?: number // 提醒类型 1|价格上涨至 2|价格下跌至 3|24H涨幅超过 4|24H跌幅超过
    alertValue?: string // 提醒价格或涨跌幅
    baseCurrency?: string // 计价币
    createdTime?: number // 创建时间，13位时间戳
    id?: number // 消息id
    quoteCurrency?: string // 标的币
    tradeId?: number // 交易对id
  }[]
>
export const getInmailPricealertLogList = (params?: TGetInmailPricealertLogListParams) => {
  return hcAxios.get<TGetInmailPricealertLogListResponse>(API.InmailPricealertLogList, { params })
}

export type TGetKafkaInmNotificationParams = any
export type TGetKafkaInmNotificationResponse = TResponse<{}>
export const getKafkaInmNotification = (params?: TGetKafkaInmNotificationParams) => {
  return hcAxios.get<TGetKafkaInmNotificationResponse>(API.KafkaInmNotification, { params })
}

export type TGetJpushInmNotificationParams = any
export type TGetJpushInmNotificationResponse = TResponse<{}>
export const getJpushInmNotification = (params?: TGetJpushInmNotificationParams) => {
  return hcAxios.get<TGetJpushInmNotificationResponse>(API.JpushInmNotification, { params })
}

export type TPostV2InmailMessageListParams = {
  count?: boolean // 是否返回总记录数，默认true
  moduleId?: number // 一级分类
  pageNum?: number // 页码
  pageSize?: number // 每页显示条数
  submoduleId?: number // 二级分类
  userId?: number // 用户ID
}
export type TPostV2InmailMessageListResponse = TBaseResponse &
  TResponse<
    {
      bizType?: BizType
      content?: string // 内容
      createdTime?: number // 创建时间，13位时间戳
      dataJson?: string // 特殊数据
      id?: string // 消息id
      jumpAppAndroid?: string // APP跳转链接
      jumpAppIos?: string // APP跳转链接
      jumpLink?: string // 网页跳转链接
      moduleCode?: ModuleCode // 一级分类
      read?: number // 已读状态 0否 1是
      submoduleCode?: ModuleCode // 二级分类
      supportCode?: string // 站内code
      title?: string // 标题
    }[]
  >
export const postV2InmailMessageList = (params?: TPostV2InmailMessageListParams) => {
  return hcAxios.post<TPostV2InmailMessageListResponse>(API.V2InmailMessageList, params)
}

export type TPostV2InmailMessageStatusParams = {
  bizType?: BizType[] // bizType 三级分类，rangeType需要=1
  messageId?: string // 消息ID
  rangeType?: RangeType // 已读 0所有 1表示一个或多个
}
export type TPostV2InmailMessageStatusResponse = TResponse<any>
export const postV2InmailMessageStatus = (params?: TPostV2InmailMessageStatusParams) => {
  return hcAxios.post<TPostV2InmailMessageStatusResponse>(API.V2InmailMessageStatus, params)
}

export type TGetV2InmailMessageUnReadCountParams = any
export type TGetV2InmailMessageUnReadCountResponse = TResponse<{
  countTotal?: number // 未读消息数量
}>
export const getV2InmailMessageUnReadCount = (params?: TGetV2InmailMessageUnReadCountParams) => {
  return hcAxios.get<TGetV2InmailMessageUnReadCountResponse>(API.V2InmailMessageUnReadCount, { params })
}

export type TGetV2InmailMessageClassifyParams = any
export type TGetV2InmailMessageClassifyResponse = TResponse<
  {
    code?: number // 分类code
    name?: string // 分类名字
    submodule?: {
      code?: SubmoduleCode
      name?: string
    }[] // 子集
  }[]
>
export const getV2InmailMessageClassify = (params?: TGetV2InmailMessageClassifyParams) => {
  return hcAxios.get<TGetV2InmailMessageClassifyResponse>(API.V2InmailMessageClassify, { params })
}
